import { create } from 'zustand'

export interface User {
  id: string
  email: string
  name: string
  avatarUrl?: string
  role: 'user' | 'admin' | 'superadmin'
}

interface AuthState {
  user: User | null
  // Se vuelve true una vez que AuthHydrator resuelve el fetch inicial a
  // /auth/me (con o sin sesión) — permite a componentes como
  // OrganizerCtaModal esperar a saber el estado real antes de decidir algo,
  // en vez de asumir "no logueado" mientras el fetch todavía está en vuelo.
  checked: boolean
  setUser: (user: User | null) => void
  clearUser: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  checked: false,
  setUser: (user) => set({ user, checked: true }),
  clearUser: () => set({ user: null, checked: true }),
}))
